import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

// Components
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';
import { WpButtonGroup, WpButton } from 'Wpds/components/button';
import { WpForm, WpFormLayout } from 'Wpds/components/form';
import { VisuallyHidden } from 'Wpds/components/visually-hidden/VisuallyHidden';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  isOpen?: boolean;
  toggleIsOpen?: () => void;
};

const ConnectHibobModal = ({ isOpen, toggleIsOpen }: Props) => {
  const { tr } = useTranslation();
  const btnRef = useRef(null);

  const hibobDataSource = useSelector(state => state.data_sources.find(({ slug }) => slug === 'hibob'));

  const handleSubmitClick = () => {
    btnRef.current.click();
  };

  const csrfValue = get(document.getElementsByName('csrf-token')[0], 'content');

  return (
    <WpModal isOpen={isOpen} size="sm" onToggle={toggleIsOpen}>
      <WpModalHeader>{tr('perform.connect.hibob.title')}</WpModalHeader>
      <WpModalBody>
        <WpForm method="post" action={hibobDataSource.path}>
          <WpFormLayout>
            <WpTextField id="user_id" name="user_id" label={tr('perform.connect.hibob.user_id_label')} required />
            <WpTextField
              id="user_api_key"
              name="user_api_key"
              label={tr('perform.connect.hibob.api_key_label')}
              required
            />
            <div style={{ visibility: 'hidden', height: '0px', position: 'absolute', top: '-1000px', left: '-1000px' }}>
              <WpTextField type="text" id="authenticity_token" label="authenticity_token" value={csrfValue} readOnly />
            </div>
            <VisuallyHidden>
              <WpButton btnType="submit" ref={btnRef}>
                {tr('perform.common.submit')}
              </WpButton>
            </VisuallyHidden>
          </WpFormLayout>
        </WpForm>
      </WpModalBody>
      <WpModalFooter>
        <WpButtonGroup>
          <WpButton variant="tertiary" onClick={toggleIsOpen}>
            {tr('perform.common.cancel')}
          </WpButton>
          <WpButton onClick={handleSubmitClick}>{tr('perform.common.save')}</WpButton>
        </WpButtonGroup>
      </WpModalFooter>
    </WpModal>
  );
};

export default ConnectHibobModal;
